import { render, staticRenderFns } from "./list-kompetisi.vue?vue&type=template&id=506fb6c6&"
import script from "./list-kompetisi.vue?vue&type=script&lang=js&"
export * from "./list-kompetisi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "list-kompetisi.vue"
export default component.exports